import { Component, OnInit } from '@angular/core';
import { NatureProduitCrm } from 'src/app/parametrage/core/model/produitCrm/natureProduitCrm';
import { TypeDocumentProduitCrm } from 'src/app/parametrage/core/model/produitCrm/type-document-produitCrm';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { NgbdModalConfirm } from 'src/app/core/services/utils/modal-confirm';
import { ProduitCrmService } from 'src/app/parametrage/core/service/produit-crm.service';
import { NatureProduitCrmDocument } from 'src/app/parametrage/core/model/produitCrm/NatureProduitCrmDocument';

@Component({
  selector: "app-set-type-document-produit-crm",
  templateUrl: "./set-type-document-produit-crm.component.html",
  styleUrls: ["./set-type-document-produit-crm.component.scss"]
})
export class SetTypeDocumentProduitCrmComponent implements OnInit {
  natureProduitCrmId: number;
  natureProduitCrm: NatureProduitCrm;
  natureProduitCrmDocuments: NatureProduitCrmDocument[];
  documents: TypeDocumentProduitCrm[];
  selectedDocumentId: number;
  isObligatoire: boolean = false;

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private _produitCrmService: ProduitCrmService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.getAllDocuments();
    this.getNatureProduitCrmDocuments();
  }

  getNatureProduitCrmDocuments() {
    this._produitCrmService
      .getNatureProduitCrmDocuments(this.natureProduitCrmId)
      .subscribe(data => {
        this.natureProduitCrmDocuments = data;
      });
  }

  getAllDocuments() {
    this._produitCrmService.getTypeDocumentProduitCrm().subscribe(data => {
      this.documents = data;
    });
  }

  addNatureProduitCrmDocument() {
    var input = new NatureProduitCrmDocument();
    input.typeDocumentProduitCrmId = this.selectedDocumentId;
    input.obligatoire = this.isObligatoire;
    this.spinner.show();
    this._produitCrmService
      .addNatureProduitCrmDocument(input, this.natureProduitCrmId)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(data => {
        this.selectedDocumentId = null;
        this.isObligatoire = false;
        this.getNatureProduitCrmDocuments();
      });
  }

  deleteDocument(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelle;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer ce type de document";
    modalConfirmRef.componentInstance.description =
      '<span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      result => {
        this.spinner.show();
        this._produitCrmService
          .deleteNatureProduitCrmDocument(row.id)
          .pipe(
            finalize(() => {
              this.spinner.hide();
            })
          )
          .subscribe(data => {
            this.getNatureProduitCrmDocuments();
          });
      },
      reason => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }
}
